import React from "react";
import { Link } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import logo from "assets/images/logo.png";
import { withRouter } from "react-router";

import Copyright from "../Components/Copyright";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24,
  },
  appBar: {
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  logoImage: {
    width: "140px" ,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  container: {
    [theme.breakpoints.down('xl')]: {
      maxWidth: "1285px",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "1480px",
    },
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  notFound: {
    fontSize: "10rem",
    fontWeight: "300",
    lineHeight: "1.167",
    letterSpacing: "-0.01562em",
  },
}));


function NotFound(props) {
  const classes = useStyles();
  const [isLogin, setIsLogin] = React.useState(false);
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    // ログインチェック
    if (localStorage.getItem("token") || localStorage.getItem("admintoken")) {
      setIsLogin(true);
      setMessage("前のページへ戻る");
    } else {
      setMessage("ログインページへ戻る");
    }

    // タイトル変更
    document.title = "Buzz Finder - Not Found";

  }, []);

  const handleClickLink = () => {
    if(isLogin) {
      props.history.goBack();
    } else {
      props.history.push("/");
    }
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="absolute"
        className={classes.appBar}
      >
        <Toolbar className={classes.toolbar}>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
          >
            <img src={logo} className={classes.logoImage}/>
          </Typography>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container className={classes.container}>
          <Typography 
            align="center"
            className={classes.notFound}
          >
            404
          </Typography>
          <Typography 
            variant="h5" 
            align="center"
          >
            Page Not Found
          </Typography>
          <Typography variant="body2" align="center">
            <p>アクセスしようとしたページは見つかりませんでした。</p>
            <p>
              <Link onClick={handleClickLink}>
                {message}
              </Link>
            </p>
          </Typography>
          <Box pt={4}>
            <Copyright />
          </Box>
        </Container>
      </main>
    </div>
  );
}

export default withRouter(NotFound);